import React from 'react';
import { Row } from 'library/ui';
import { IHourReport } from 'internal/payments/HourReportModels';
import { TitleDescription } from './TitleDescription';
import { format12HourTime } from 'shared/Dates';

export function BusinessSlotHourReportDetails({ hourReport }: { hourReport: IHourReport }) {
    return (
        <Row gap="md" wrap>
            {hourReport.start ? (
                <TitleDescription title="Clocked In" description={`${format12HourTime(hourReport.start)}`} />
            ) : (
                <TitleDescription title="Reported Late" description={`${hourReport.late_minutes} minutes`} />
            )}
            {hourReport.end ? (
                <TitleDescription title="Clocked Out" description={`${format12HourTime(hourReport.end)}`} />
            ) : null}
            {(hourReport.approved_break ?? 0) > 0 ? (
                <TitleDescription title="Break" description={`${hourReport.approved_break} minutes`} />
            ) : null}
            {(hourReport.hours_worked ?? 0) > 0 ? (
                <TitleDescription title="Total Hours" description={`${hourReport.hours_worked} hours`} />
            ) : null}
        </Row>
    );
}
